import React from 'react';
import useAddress from 'hooks/useAddress';

const Address = () => {
  const [addressList, loading] = useAddress();

  return (
    <div className="coop-l-container">
      <h2>Address</h2>
      {loading && <div>Loading</div>}
      {!loading &&
        addressList.length > 0 &&
        addressList.map((add) => (
          <div key={add.name}>
            <p>{add.postcode}</p>
          </div>
        ))}
    </div>
  );
};

export default Address;
